export class InternetCheckService {
    async check(url = 'https://www.cloudflare.com/cdn-cgi/trace', attempts = 5, intervalMilli = 1000, timeoutMilli = 3000) {
        let stableCount = 0
        let totalLatency = 0

        for (let i = 0; i < attempts; i++) {
            const startTime = Date.now()

            try {
                const controller = new AbortController()
                const timer = setTimeout(() => controller.abort(), timeoutMilli)

                await fetch(url, { signal: controller.signal })
                const latency = Date.now() - startTime
                totalLatency += latency
                stableCount++

                clearTimeout(timer)
                console.log(`Attempt ${i + 1}: Latency ${latency}ms - Success`)
            } catch (error) {
                console.log(`Attempt ${i + 1}: Failed`)
            }

            // Pequeno intervalo entre as tentativas
            await new Promise((res) => setTimeout(res, intervalMilli))
        }

        const stability = (stableCount / attempts) * 100
        const avgLatency = stableCount > 0 ? totalLatency / stableCount : 0

        console.log(`\nStability: ${stability.toFixed(2)}%`)
        console.log(`Average Latency: ${avgLatency.toFixed(2)}ms`)

        return { stability: stability >= 80 && avgLatency < 1000, level: stability }
    }
}
